import { render, staticRenderFns } from "./ExclamationTriangleIcon.vue?vue&type=template&id=25765a5e&"
import script from "./ExclamationTriangleIcon.vue?vue&type=script&lang=js&"
export * from "./ExclamationTriangleIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports